//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { convertTime } from '../../components/helpers.js'
import TableServer from '../../components/Table/Table.vue'
import VehicleCardRemarkImages from './VehicleCardRemarkImages.vue'

function formatRemarkStatus (value) {
  if (value === 'notFixed') {
    return 'Не устранено'
  } else if (value === 'fixed') {
    return 'Устранено'
  } else {
    return ''
  }
}

export default {
  name: 'VehicleCardSectionRemarks',
  components: {
    TableServer,
    VehicleCardRemarkImages
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      additionalUrlParams: {
        vehicleId: null
      },
      columns: [
        {
          name: 'number',
          label: '№',
          align: 'left',
          field: 'number',
          sortable: true
        },
        {
          name: 'registeredDate',
          label: 'Дата/время операции',
          align: 'left',
          field: 'registeredDate',
          sortable: true,
          format: convertTime
        },
        {
          name: 'remarkStatus',
          label: 'Статус',
          align: 'left',
          field: 'remarkStatus',
          sortable: true,
          format: formatRemarkStatus
        },
        {
          name: 'description',
          label: 'Описание',
          align: 'left',
          field: 'description',
          sortable: false
        }
      ]
    }
  },
  watch: {
    objectSrc: {
      handler: function (object) {
        if (object) {
          this.additionalUrlParams.vehicleId = object.id
        } else {
          this.additionalUrlParams.vehicleId = null
        }
      },
      immediate: true
    }
  },
  methods: {
    onOpenRecord: function (data) {
      this.$router.push('/journals/vehicleRemarks/' + data.id)
    }
  }
}
